<template>
    <seccion-datos :titulo="facturacion" tipo="danger"  @cambios="guardar(id)">                    
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.clave') }}</label>
                    <input  v-model="clave_certificado" type="password" class="form-control nombre_completo dato" id="nombre_completo">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label class="d-block">{{ $t('general.certificadodigital') }}</label>
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <FileUpload mode="basic" :maxFileSize="20000000" @select="onSelect($event)" :auto="true" chooseLabel="Certificado" />
                        <span v-if="ruta_certificado" class="badge badge-secondary">Existe</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-12">
                    <p class="text-yellow">{{ $t('general.descripcionclave') }}</p>
                </div>
                <div class="col-md-4">
                </div>
            </div>
        </div>
    </seccion-datos>
</template>
<script>
import { PwgsApi } from '../../../../services/PwgsApi';
import FileUpload from 'primevue/fileupload';
export default {
    components: {
        FileUpload,
    },
    props: ['id', 'verifactu', 'bloqueo'],
    data() {
        return {
            empresa: '',
            ruta_certificado: '',
            clave_certificado: '',
            seleccionado: '',
            facturacion: '',
        }
    },
    methods: {
        async onSelect(event) {
            let subidadatos;
            const formData = new FormData();
            formData.append('certificado', event.files[0]);
            const api = new PwgsApi;
            if (this.id > 0) {
                console.log('es1');
                try {
                    await api.post('empresas/' + this.id+ '/subir-certificado', formData);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
            else {
                console.log('es2');
                /* post  modulos/pwgsapi/index.php/lineas-facturacion/  */
                try {
                    let res;
                    res = await api.post('empresas/', subidadatos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    this.$router.push('/empresas/' + res.id);
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
        async obtenerEmpresa(id) {
            const api = new PwgsApi;
            const datos = await api.get('empresas/' + id);
            this.empresa = datos.datos;
            this.$store.dispatch('cambiarCargando', true);
            this.ruta_certificado = this.empresa.ruta_certificado;
            this.clave_certificado = this.empresa.clave_certificado;
            this.$store.dispatch('cambiarCargando', false);
            this.facturacion = this.$t('general.facturacion');
        },
        async guardar(id) {
            /* put  modulos/pwgsapi/index.php/lineas-facturacion/:id   */
            const subidadatos = {clave_certificado: this.clave_certificado};
            const api = new PwgsApi;
            if (this.id > 0) {
                try {
                    this.$store.dispatch('cambiarGuardando', true);
                    await api.put('empresas/' + this.id, subidadatos);
                    this.$store.dispatch('cambiarGuardando', false);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    this.obtenerEmpresa(id);
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
            else {
                /* post  modulos/pwgsapi/index.php/lineas-facturacion/  */
                try {
                    let res;
                    res = await api.post('empresas/', subidadatos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
                    this.$router.push('/empresas/' + res.id);
                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
                }
            }
        },
    },
    mounted() {

        this.obtenerEmpresa(this.id);
    },
    watch: {
        id() {
            this.obtenerEmpresa(this.id);
        }
    }
}
</script>